<template>
  <div class="score" :class="{'score--won': hasWon, 'score--lost': hasLost}">
    <h1 class="title">
      <template v-if="hasWon">
        Yeah!
      </template>
      <template v-if="hasLost">
        Damn!
      </template>
    </h1>
    <div class="moves">
      It took you <strong>{{ moves }}</strong> moves to
      <template v-if="hasWon">
        win and find <strong>{{ numberOfCardTypes }}</strong> pairs. Good job!
      </template>
      <template v-if="hasLost">
        lose. Don't worry, finding <strong>{{ numberOfCardTypes }}</strong> pairs is hard.
        I'm sure you did your best.
      </template>
    </div>
    <BigButton @click="endGame">
      Start a new game
    </BigButton>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';


  export default {
    name: 'Score',
    props: {},
    computed: {
      ...mapGetters([
        'moves',
        'hasWon',
        'hasLost',
        'numberOfCardTypes',
      ]),
    },
    methods: {
      ...mapActions([
        'endGame',
      ]),
    },
  };
</script>

<style scoped lang="scss">
  @import "../config/styles/settings";
  @import "../config/styles/util";

  .score {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ($gutter * 2);
    color: $blue-500;
  }

  .score.score--won {
  }

  .score.score--lost {
  }

  .title {
    font-size: 6rem;
    margin: 0 0 ($gutter * 2);
  }

  .moves {
    margin-bottom: ($gutter * 2);
  }
</style>
